export default __webpack_public_path__ + "static/media/Intimation-of-Analyst-Meet-June-10-2026.cbaf18da.pdf";